function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 3.05176e-05H2.5C1.4 3.05176e-05 0.51 0.90003 0.51 2.00003L0.5 20L4.5 16H18.5C19.6 16 20.5 15.1 20.5 14V2.00003C20.5 0.90003 19.6 3.05176e-05 18.5 3.05176e-05ZM6.5 12H4.5V10H6.5V12ZM6.5 9.00003H4.5V7.00003H6.5V9.00003ZM6.5 6.00003H4.5V4.00003H6.5V6.00003ZM13.5 12H8.5V10H13.5V12ZM16.5 9.00003H8.5V7.00003H16.5V9.00003ZM16.5 6.00003H8.5V4.00003H16.5V6.00003Z",
  fillOpacity: 1,
  fill: "#141414"
});

function SvgSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.b68a284c.svg";
export { ForwardRef as ReactComponent };